/* eslint-disable no-underscore-dangle */
export const GEOSERVER_BEARER = (window as any)._env_.REACT_APP_GEOSERVER_BEARER || 'Basic YWRtaW46TWV0Q29uc29sZUdpcy4hMTIzNA==';
export const METCONSOLE_FIWARE_SERVICE = (window as any)._env_.REACT_APP_METCONSOLE_WEBTOKEN || 'Basic ZHRuOmR0bg==';
export const KEYCLOAK_CLIENT_ID = (window as any)._env_.REACT_APP_KEYCLOAK_CLIENT_ID || 'dtn';

export const DTN_CLIENT_ID = (window as any)._env_.REACT_APP_DTN_CLIENT_ID || '';
export const DTN_CLIENT_SECRET = (window as any)._env_.REACT_APP_DTN_CLIENT_SECRET || '';
